var $04c60c697ee9de36$exports = {};
// WTF 11.05
const $04c60c697ee9de36$var$username = "pawel-haraf";
const $04c60c697ee9de36$var$username1 = "makiekwtfowicz";
const $04c60c697ee9de36$var$username2 = "maciejkorsan";
const $04c60c697ee9de36$var$direction = "desc";
const $04c60c697ee9de36$var$repositoriesContainer = document.querySelector(".repositories--js");
fetch(`https://api.github.com/users/${$04c60c697ee9de36$var$username}/repos?direction=${$04c60c697ee9de36$var$direction}`).then((response)=>response.json()).then((response)=>{
    for (let repository of response){
        const { name: name, html_url: html_url } = repository;
        const element = `<li><a href="${html_url}">${name}</a></li>`;
        $04c60c697ee9de36$var$repositoriesContainer.insertAdjacentHTML("beforeend", element);
    }
}).catch((e)=>console.log(e));


//# sourceMappingURL=index.0d7c3d9b.js.map
